"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RequiredIndicator = _interopRequireDefault(require("../required/RequiredIndicator"));

var _BestLabel = _interopRequireDefault(require("./BestLabel"));

var _NumberInput = _interopRequireDefault(require("./NumberInput"));

var _RequiredInput = _interopRequireDefault(require("../required/RequiredInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputHolder = _styledComponents["default"].div.withConfig({
  displayName: "CreditCardInput__InputHolder",
  componentId: "sc-9kfav4-0"
})(["width:100%;"]);

var CreditCardFourNumberInput = function CreditCardFourNumberInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      setLastFour = _ref.setLastFour,
      rest = _objectWithoutProperties(_ref, ["value", "onChange", "setLastFour"]);

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      firstFour = _useState2[0],
      setFirstFour = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      secondFour = _useState4[0],
      setSecondFour = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      thirdFour = _useState6[0],
      setThirdFour = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      fourthFour = _useState8[0],
      setFourthFour = _useState8[1];

  var firstInput = (0, _react.useRef)();
  var secondInput = (0, _react.useRef)();
  var thirdInput = (0, _react.useRef)();
  var fourthInput = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    onChange(firstFour + secondFour + thirdFour + fourthFour);
  }, [firstFour, secondFour, thirdFour, fourthFour]);

  var validateFunc = function validateFunc(value) {
    return value.length === 4;
  };

  var handleChange = function handleChange(val, setters, nextInput) {
    if (val.length > 5 && val.length <= 16) {
      setFirstFour(val.substring(0, 4));
      setSecondFour(val.substring(4, 8));
      setThirdFour(val.substring(8, 12));
      setFourthFour(val.substring(12, 16));
      setLastFour(val.substring(12, 16));
    } else if (val.length <= 4) {
      setters.forEach(function (setter) {
        setter(val);
      });

      if (val.length === 4) {
        if (nextInput && nextInput.current) {
          nextInput.current.focus();
        }
      }
    }
  };

  return _react["default"].createElement("div", _extends({
    className: "mt-2"
  }, rest), _react["default"].createElement(_BestLabel["default"], {
    htmlFor: "cardNumber1"
  }, "Card Number ", _react["default"].createElement(_RequiredIndicator["default"], null)), _react["default"].createElement("div", {
    className: "d-flex"
  }, _react["default"].createElement(InputHolder, null, _react["default"].createElement(_RequiredInput["default"], {
    name: "cardNumber1",
    validateFunc: validateFunc
  }, _react["default"].createElement(_NumberInput["default"], {
    name: "cardNumber1",
    value: firstFour,
    placeholder: "# # # #",
    onChange: function onChange(val) {
      handleChange(val, [setFirstFour], secondInput);
    },
    className: "mr-2",
    innerRef: firstInput
  }))), _react["default"].createElement(InputHolder, null, _react["default"].createElement(_RequiredInput["default"], {
    name: "cardNumber2",
    validateFunc: validateFunc
  }, _react["default"].createElement(_NumberInput["default"], {
    value: secondFour,
    placeholder: "# # # #",
    onChange: function onChange(val) {
      handleChange(val, [setSecondFour], thirdInput);
    },
    className: "mr-2",
    innerRef: secondInput
  }))), _react["default"].createElement(InputHolder, null, _react["default"].createElement(_RequiredInput["default"], {
    name: "cardNumber3",
    validateFunc: validateFunc
  }, _react["default"].createElement(_NumberInput["default"], {
    value: thirdFour,
    placeholder: "# # # #",
    onChange: function onChange(val) {
      handleChange(val, [setThirdFour], fourthInput);
    },
    className: "mr-2",
    innerRef: thirdInput
  }))), _react["default"].createElement(InputHolder, null, _react["default"].createElement(_RequiredInput["default"], {
    name: "cardNumber4",
    validateFunc: validateFunc
  }, _react["default"].createElement(_NumberInput["default"], {
    value: fourthFour,
    placeholder: "# # # #",
    onChange: function onChange(val) {
      handleChange(val, [setFourthFour, setLastFour]);
    },
    innerRef: fourthInput
  })))));
};

CreditCardFourNumberInput.defaultProps = {
  setLastFour: function setLastFour() {}
};
CreditCardFourNumberInput.propTypes = {
  /** the value of the current credit card number */
  value: _propTypes["default"].string.isRequired,

  /** setter for the credit card number value */
  onChange: _propTypes["default"].func.isRequired,

  /** Setter for last four  */
  setLastFour: _propTypes["default"].func
};

var CreditCardAmexInput = function CreditCardAmexInput(_ref2) {
  var value = _ref2.value,
      onChange = _ref2.onChange,
      setLastFour = _ref2.setLastFour,
      rest = _objectWithoutProperties(_ref2, ["value", "onChange", "setLastFour"]);

  var _useState9 = (0, _react.useState)(""),
      _useState10 = _slicedToArray(_useState9, 2),
      firstVal = _useState10[0],
      setFirstVal = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = _slicedToArray(_useState11, 2),
      secondVal = _useState12[0],
      setSecondVal = _useState12[1];

  var _useState13 = (0, _react.useState)(""),
      _useState14 = _slicedToArray(_useState13, 2),
      thirdVal = _useState14[0],
      setThirdVal = _useState14[1];

  var firstInput = (0, _react.useRef)();
  var secondInput = (0, _react.useRef)();
  var thirdInput = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    onChange(firstVal + secondVal + thirdVal);
  }, [firstVal, secondVal, thirdVal]);

  var validateFirstVal = function validateFirstVal(value) {
    return value.length === 4;
  };

  var validateSecondVal = function validateSecondVal(value) {
    return value.length === 6;
  };

  var validateThirdVal = function validateThirdVal(value) {
    return value.length === 5;
  };

  var handleFirstVal = function handleFirstVal(value) {
    if (value.length <= 4) {
      setFirstVal(value);

      if (value.length === 4) {
        if (secondInput && secondInput.current) {
          secondInput.current.focus();
        }
      }
    } else if (value.length > 5) {
      setFirstVal(value.substring(0, 4));
      setSecondVal(value.substring(4, 10));
      setThirdVal(value.substring(10, 15));
      setLastFour(value.substring(11, 15));
    }
  };

  var handleSecondVal = function handleSecondVal(value) {
    if (value.length <= 6) {
      setSecondVal(value);

      if (value.length === 6) {
        if (thirdInput && thirdInput.current) {
          thirdInput.current.focus();
        }
      }
    }
  };

  var handleThirdVal = function handleThirdVal(value) {
    if (value.length <= 5) {
      setThirdVal(value);
    }

    if (value.length >= 2 && value.length <= 5) {
      setLastFour(value.substring(1, value.length));
    }
  };

  return _react["default"].createElement("div", _extends({
    className: "mt-2"
  }, rest), _react["default"].createElement(_BestLabel["default"], {
    htmlFor: "cardNumebr1"
  }, "Card Number ", _react["default"].createElement(_RequiredIndicator["default"], null)), _react["default"].createElement("div", {
    className: "d-flex"
  }, _react["default"].createElement(InputHolder, null, _react["default"].createElement(_RequiredInput["default"], {
    name: "cardNumber1",
    validateFunc: validateFirstVal
  }, _react["default"].createElement(_NumberInput["default"], {
    name: "cardNumber1",
    placeholder: "# # # #",
    onChange: handleFirstVal,
    value: firstVal,
    innerRef: firstInput,
    className: "mr-2"
  }))), _react["default"].createElement(InputHolder, null, _react["default"].createElement(_RequiredInput["default"], {
    name: "cardNumber2",
    validateFunc: validateSecondVal
  }, _react["default"].createElement(_NumberInput["default"], {
    placeholder: "# # # # # #",
    onChange: handleSecondVal,
    value: secondVal,
    innerRef: secondInput,
    className: "mr-2"
  }))), _react["default"].createElement(InputHolder, null, _react["default"].createElement(_RequiredInput["default"], {
    name: "cardNumber3",
    validateFunc: validateThirdVal
  }, _react["default"].createElement(_NumberInput["default"], {
    placeholder: "# # # # #",
    onChange: handleThirdVal,
    value: thirdVal,
    innerRef: thirdInput
  })))));
};

CreditCardAmexInput.defaultProps = {
  setLastFour: function setLastFour() {}
};
CreditCardAmexInput.propTypes = {
  /** the value of the current credit card number */
  value: _propTypes["default"].string.isRequired,

  /** setter for the credit card number value */
  onChange: _propTypes["default"].func.isRequired,

  /** Setter for last four  */
  setLastFour: _propTypes["default"].func
};

var CreditCardInput = function CreditCardInput(_ref3) {
  var isAmex = _ref3.isAmex,
      value = _ref3.value,
      onChange = _ref3.onChange,
      setLastFour = _ref3.setLastFour,
      rest = _objectWithoutProperties(_ref3, ["isAmex", "value", "onChange", "setLastFour"]);

  return isAmex ? _react["default"].createElement(CreditCardAmexInput, _extends({
    value: value,
    onChange: onChange,
    setLastFour: setLastFour
  }, rest)) : _react["default"].createElement(CreditCardFourNumberInput, _extends({
    value: value,
    onChange: onChange,
    setLastFour: setLastFour
  }, rest));
};

CreditCardInput.defaultProps = {
  isAmex: false,
  setLastFour: function setLastFour() {}
};
CreditCardInput.propTypes = {
  /** is the card is an Amex or not */
  isAmex: _propTypes["default"].bool,

  /** the value of the current credit card number */
  value: _propTypes["default"].string.isRequired,

  /** setter for the credit card number value */
  onChange: _propTypes["default"].func.isRequired,

  /** Setter for last four  */
  setLastFour: _propTypes["default"].func
};
var _default = CreditCardInput;
exports["default"] = _default;